<script setup lang="ts">
  import type { PageSwitcherStoryblok } from '@/storyblok/component-types-sb'
  import { getCompactLinkData } from '@/utils/storyblok/getCompactLinkData'

  const props = defineProps<{
    blok: PageSwitcherStoryblok
  }>()

  const links = computed(() => {
    return props.blok.links.map((link) => {
      return {
        ...link,
        link: getCompactLinkData(link.link)
      }
    })
  })
</script>

<template>
  <div class="mx-auto flex min-w-80 flex-wrap rounded-xs bg-grey p-1 lg:my-4">
    <NuxtLink
      v-for="link in links"
      :key="link._uid"
      :to="link.link.href"
      class="flex flex-1 basis-0 items-center justify-center whitespace-nowrap rounded-xs px-5 py-2 text-center text-base no-underline transition sm:px-6 lg:px-4"
      active-class="bg-white font-medium shadow-sm"
    >
      {{ link.label || link.link.text }}
    </NuxtLink>
  </div>
</template>
